import { useState } from "react";
import { createPortal } from "react-dom";

export default function IFrame({ title, children = undefined, ...props }) {
  const [contentRef, setContentRef] = useState(null);
  const mountNode = contentRef?.contentWindow?.document?.body;

  return (
    <iframe {...props} ref={setContentRef} title={title}>
      {mountNode && createPortal(children, mountNode)}
    </iframe>
  );
}
